export interface AttendanceTableDataType {
    project_id?: number;
    site_address?: string;
    present?: number;
    absent?: number;
    halfday?: number;
}


// to single object maping
export const mapAttendanceTableDataType = (data:any): AttendanceTableDataType => {
    if(!data){
        throw new Error('Invalid Data')
    }
    const  res: AttendanceTableDataType ={
        project_id: data.project_id,
        site_address: data.site_address,
        present: data.present,
        absent: data.absent,
        halfday: data.halfday,
       
      
    }
    return res;
}

// maping list objects
export const mapAttendanceTableDataTypes = (data:any[]): AttendanceTableDataType[] => {
     if (!Array.isArray(data)) {
       throw new Error('Invalid Data');
     }
     return data.map(mapAttendanceTableDataType);
}